import { StepFormBase } from 'core/components';
import _ from 'lodash';

export default class MarketplaceOrderEditForm extends StepFormBase {
	constructor(hooks) {
		super(hooks);
		this.setForm(this);
	}

	setup() {
		return {
			...this.getMergedForm([
				MarketplaceOrderEditOrderStepForm(),
				MarketplaceOrderEditOrderLinesStepForm(),
				MarketplaceOrderEditShippingStepForm(),
				MarketplaceOrderEditAssignmentStepForm(),
			]),
		};
	}
}

function MarketplaceOrderEditOrderStepForm() {
	return {
		fields: [
			'orderStep.sellerId',
			'orderStep.id',
			'orderStep.orderNumber',
			'orderStep.shipByDate',
			'orderStep.deliverByDate',
			'orderStep.orderDate',
			'orderStep.amountPaid',
			'orderStep.internalNote',
			'orderStep.orderTypeId',
			'orderStep.ref1',
			'orderStep.ref2',
			'orderStep.ref3',
			'orderStep.paymentDate',
			'orderStep.channelId',
			'orderStep.orderStatusId',
		],
		labels: {
			'orderStep.sellerId': 'MARKETPLACEORDEREDITFORM.SELLER',
			'orderStep.orderNumber': 'MARKETPLACEORDEREDITFORM.ORDERNUMBER',
			'orderStep.shipByDate': 'MARKETPLACEORDEREDITFORM.SHIPBYDATE',
			'orderStep.deliverByDate': 'MARKETPLACEORDEREDITFORM.DELIVERBYDATE',
			'orderStep.orderDate': 'MARKETPLACEORDEREDITFORM.ORDERDATE',
			'orderStep.orderStatusId': 'MARKETPLACEORDEREDITFORM.ORDERSTATUS',
			'orderStep.amountPaid': 'MARKETPLACEORDEREDITFORM.AMOUNTPAID',
			'orderStep.internalNote': 'MARKETPLACEORDEREDITFORM.INTERNALNOTE',
			'orderStep.orderTypeId': 'MARKETPLACEORDEREDITFORM.ORDERTYPE',
			'orderStep.ref1': 'MARKETPLACEORDEREDITFORM.REF1',
			'orderStep.ref2': 'MARKETPLACEORDEREDITFORM.REF2',
			'orderStep.ref3': 'MARKETPLACEORDEREDITFORM.REF3',
			'orderStep.channelId': 'MARKETPLACEORDEREDITFORM.CHANNEL',
			'orderStep.paymentDate': 'MARKETPLACEORDEREDITFORM.PAYMENTDATE',
			'orderStep.orderStatusId': 'MARKETPLACEORDEREDITFORM.ORDERSTATUS',
		},
		rules: {
			'orderStep.orderNumber': 'required',
			'orderStep.shipByDate': 'required',
			'orderStep.orderDate': 'required',
			'orderStep.confirmationType': 'required',
			'orderStep.orderTypeId': 'required',
			'orderStep.orderStatusId': 'required',
			'orderStep.paymentDate': 'required',
		},
	};
}

function MarketplaceOrderEditOrderLinesStepForm() {
	return {
		fields: [
			'orderLinesStep.orderLines',
			'orderLinesStep.orderLines[].quantity',
			'orderLinesStep.orderLines[].unitPrice',
			'orderLinesStep.orderLines[].orderLineStatusId',
			'orderLinesStep.orderLines[].taxPaid',
			'orderLinesStep.orderLines[].id',
			'orderLinesStep.orderLines[].productId',
			'orderLinesStep.orderLines[].sellerId',
		],
		labels: {
			'orderLinesStep.orderLines[].productId': 'MARKETPLACEORDEREDITFORM.SKU',
			'orderLinesStep.orderLines[].quantity': 'MARKETPLACEORDEREDITFORM.QUANTITY',
			'orderLinesStep.orderLines[].unitPrice': 'MARKETPLACEORDEREDITFORM.UNITPRICE',
			'orderLinesStep.orderLines[].orderLineStatusId': 'MARKETPLACEORDEREDITFORM.ORDERLINESTATUS',
			'orderLinesStep.orderLines[].taxPaid': 'MARKETPLACEORDEREDITFORM.TAXPAID',
		},
		rules: {
			'orderLinesStep.orderLines[].productId': 'required',
			'orderLinesStep.orderLines[].quantity': 'required|numeric|numericMinValue|notZero|integer',
			'orderLinesStep.orderLines[].orderLineStatusId': 'required',
			'orderLinesStep.orderLines[].unitPrice': 'numeric|decimalLength',
			'orderLinesStep.orderLines[].taxPaid': 'numeric|decimalLength',
		},
	};
}

function MarketplaceOrderEditShippingStepForm() {
	return {
		fields: [
			'shippingStep.shippingAddress1',
			'shippingStep.shippingAddress2',
			'shippingStep.shippingAddress3',
			'shippingStep.shippingCoreCountryId',
			'shippingStep.shippingCoreCountryStateId',
			'shippingStep.shippingPaid',
			'shippingStep.shippingCity',
			'shippingStep.currencyId',
			'shippingStep.shippingZipCode',
			'shippingStep.customerNote',
			'shippingStep.buyerName',
			'shippingStep.buyerEmail',
			'shippingStep.buyerPhone',
			'shippingStep.confirmationTypeId',
		],
		labels: {
			'shippingStep.shippingAddress1': 'MARKETPLACEORDEREDITFORM.SHIPPINGADDRESS1',
			'shippingStep.shippingAddress2': 'MARKETPLACEORDEREDITFORM.SHIPPINGADDRESS2',
			'shippingStep.shippingAddress3': 'MARKETPLACEORDEREDITFORM.SHIPPINGADDRESS3',
			'shippingStep.shippingCoreCountryId': 'MARKETPLACEORDEREDITFORM.SHIPPINGCOUNTRY',
			'shippingStep.shippingCoreCountryStateId': 'MARKETPLACEORDEREDITFORM.SHIPPINGSTATE',
			'shippingStep.shippingPaid': 'MARKETPLACEORDEREDITFORM.SHIPPINGPAID',
			'shippingStep.shippingCity': 'MARKETPLACEORDEREDITFORM.SHIPPINGCITY',
			'shippingStep.shippingZipCode': 'MARKETPLACEORDEREDITFORM.SHIPPINGZIPCODE',
			'shippingStep.confirmationTypeId': 'MARKETPLACEORDEREDITFORM.CONFIRMATIONTYPE',
			'shippingStep.buyerName': 'MARKETPLACEORDEREDITFORM.BUYERNAME',
			'shippingStep.buyerEmail': 'MARKETPLACEORDEREDITFORM.BUYEREMAIL',
			'shippingStep.buyerPhone': 'MARKETPLACEORDEREDITFORM.PHONE',
			'shippingStep.currencyId': 'MARKETPLACEORDEREDITFORM.CURRENCY',
			'shippingStep.customerNote': 'MARKETPLACEORDEREDITFORM.CUSTOMERNOTE',
		},
		rules: {
			'shippingStep.shippingAddress1': 'required',
			'shippingStep.shippingCoreCountryId': 'required',
			'shippingStep.shippingCoreCountryStateId': 'required',
			'shippingStep.shippingCity': 'required',
			'shippingStep.shippingZipCode': 'required',
			'shippingStep.buyerName': 'required',
			'shippingStep.buyerEmail': 'email',
			'shippingStep.buyerPhone': 'required',
			'shippingStep.shippingPaid': 'numeric',
		},
		values: {
			'shippingStep.confirmationTypeId': null,
			'shippingStep.currencyId': null,
		},
	};
}

function MarketplaceOrderEditAssignmentStepForm() {
	return {
		fields: ['assignmentStep.requiredCarrierService', 'assignmentStep.requiredWarehouse'],
		labels: {
			'assignmentStep.requiredCarrierService': 'MARKETPLACEORDEREDITFORM.REQUIREDCARRIERSERVICE',
			'assignmentStep.requiredWarehouse': 'MARKETPLACEORDEREDITFORM.REQUIREDWAREHOUSE',
		},
		rules: {},
		values: {
			'assignmentStep.requiredCarrierService': null,
			'assignmentStep.requiredWarehouse': null,
		},
	};
}



// WEBPACK FOOTER //
// ./src/modules/order/forms/wizard/MarketplaceOrderEditForm.js